// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__1F8ax","form":"style_form__1gB4-","group":"style_group__2E1po","error":"style_error__GU2Tq"};